export const TRANSITION_DURATION = 600;
export const TRANSITION_DURATION_SLOW = 800;
export const TRANSITION_DEFAULT_Y_OFFSET = 10;
export const TRANSITION_SLIDE_Y_OFFSET = 50;
export const TRANSITION_BLUR_AMOUNT = 3;
export const TRANSITION_SCALE_START = 0.8;
